document.querySelectorAll('.js-faq-toggle-question').forEach(toggle => {
  toggle.addEventListener('click', function () {
    const question = this.closest('.js-faq-question');
    const answer = question.querySelector('.js-faq-question-answer');

    if (answer.style.maxHeight) {
      question.classList.remove('active');
      answer.style.maxHeight = null;
      answer.style.opacity = 0;
    } else {
      question.classList.add('active');
      answer.style.maxHeight = answer.scrollHeight + "px";
      answer.style.opacity = 1;
    }
  });
});